// MUI X DataGrid v8+ describes the row selection as { type: 'include' | 'exclude', ids: Set }.
// "Select all" produces { type: 'exclude', ids: <rows NOT selected> }, so the selected ids
// must be computed against the rows on screen.

export const emptyRowSelection = () => ({ type: 'include', ids: new Set() });

export const getSelectedRowIds = (model, rows = [], getRowId = (row) => row.id) => {
  if (!model) return [];
  if (Array.isArray(model) || model instanceof Set) return [...model];
  const ids = model.ids ?? new Set();
  if (model.type === 'exclude') return rows.map(getRowId).filter((id) => !ids.has(id));
  return [...ids];
};
